import { useState, useCallback } from 'react'

function findStepIndex (steps, step) {
    return steps.indexOf(step)
}

function makeGetNextStep (steps, setLastStep) {
    return (step) => {
        const currentStepIndex = findStepIndex(steps, step)
        const maxStepIndex = steps.length - 1
        const nextStepIndex = Math.min(currentStepIndex + 1, maxStepIndex)
        setLastStep(step)
        return steps[nextStepIndex]
    }
}

function makeGetPrevStep (steps, setLastStep) {
    return (step) => {
        const currentStepIndex = findStepIndex(steps, step)
        const minStepIndex = 0
        const prevStepIndex = Math.max(currentStepIndex - 1, minStepIndex)
        setLastStep(step)

        return steps[prevStepIndex]
    }
}

/**
 * @param steps - Ordered array of step names
 * @param initialStep - Initial step name
 */
export default function useSteps ({ steps, initialStep }) {
    const [currentStep, setCurrentStep] = useState(initialStep)
    const [lastStep, setLastStep] = useState(initialStep)

    const getNextStep = useCallback(makeGetNextStep(steps, setLastStep))
    const getPrevStep = useCallback(makeGetPrevStep(steps, setLastStep))
    const goToNextStep = useCallback(() => { setCurrentStep(getNextStep) }, [getNextStep])
    const goToPrevStep = useCallback(() => { setCurrentStep(getPrevStep) }, [getPrevStep])
    const goToStep = useCallback((step) => {
        setLastStep(currentStep)
        setCurrentStep(step)
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [])

    return {
        currentStep,
        lastStep,
        goToStep,
        goToNextStep,
        goToPrevStep,
    }
}
